import React from 'react'
import { AiFillCheckCircle, AiOutlineCheckCircle } from 'react-icons/ai';

/**
 * A component that renders a check icon based on the given status and trueString.
 * #doneCheck
 *  #core
 * If trueString is set to true, the component will render a check icon if the status matches the trueString, and an outline check icon otherwise.
 * If trueString is set to false, the component will render a check icon if the status is true, and an outline check icon otherwise.
 * 
 * The component can also be clicked, and will call the given onClick function when clicked.
 * 
 * The size of the icon can be set with the size prop, and the color of the outline icon can be set with the falseColor prop.
 * 
 * @param {function} onClick - The function to call when the icon is clicked.
 * @param {boolean|string} status - The status of the icon. If trueString is true, this should be a boolean or string matching the trueString. If trueString is false, this should be a boolean.
 * @param {boolean} trueString - Whether to render a check icon if the status matches the trueString. Default is true.
 * @param {number} size - The size of the icon. Default is 25.
 * @param {string} falseColor - The color of the outline icon. Default is "red".
 */
const CheckIconComp = ({onClick, status, trueString=true, size=25, falseColor="red"}) => {

  const icon = () => {
    if (trueString) {
      if (status == trueString) return <AiFillCheckCircle size={size} color={"green"}/>
      return <AiOutlineCheckCircle size={size} color={falseColor}/>
    } 
    if (status) return <AiFillCheckCircle size={size} color={"green"}/>
    return <AiOutlineCheckCircle size={size} color={falseColor}/>
    
  }

  return (
    <div > 
        <div  onClick={onClick}>
            {icon()}
        </div>   
    </div>
  )
}

export default CheckIconComp
 